var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attachment"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/fujian.png")}}),_c('p',[_vm._v(_vm._s(_vm.info.fileName))])]),_c('a',{attrs:{"href":_vm.src,"download":_vm.info.fileName}},[_vm._v("下载")])])}
var staticRenderFns = []

export { render, staticRenderFns }